<button (click)="onScrollTo()"
    [ngClass]="{active: visible}"
    class="scroll-to-top-btn">
  <i class="fas fa-chevron-up"></i>
</button>
